import * as REPORT_ACTION_TYPES from '../report/actionTypes';

import { ReportActions, IReportState } from './types';

const initialState: IReportState = {
  total: 0,
  screenedList: [],
  enrolledPatientList: [],
  duplicatePatientList: [],
  assessmentList: [],
  userPerformanceList: [],
  loading: false,
  error: null,
  ssReport: {
    list: [],
    loading: false,
    total: 0,
    error: null
  },
  skReport: {
    list: [],
    loading: false,
    total: 0,
    error: null
  },
  skDetails: {
    list: [],
    loading: false,
    total: 0,
    error: null,
    view: null,
    viewLoading: false
  }
};

const reportReducer = (state: IReportState = initialState, action: ReportActions) => {
  switch (action.type) {
    case REPORT_ACTION_TYPES.FETCH_SCREENED_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.payload.totalCount || 0,
        screenedList: action.payload.screenedList || []
      };
    case REPORT_ACTION_TYPES.FETCH_ASSESSMENT_LIST_REQUEST:
    case REPORT_ACTION_TYPES.FETCH_ENROLLED_PATIENT_REQUEST:
    case REPORT_ACTION_TYPES.FETCH_SCREENED_PATIENT_LIST_REQUEST:
    case REPORT_ACTION_TYPES.FETCH_USER_PERFORMANCE_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case REPORT_ACTION_TYPES.FETCH_ASSESSMENT_LIST_FAILURE:
    case REPORT_ACTION_TYPES.FETCH_ENROLLED_PATIENT_FAILURE:
    case REPORT_ACTION_TYPES.FETCH_SCREENED_PATIENT_FAILURE:
    case REPORT_ACTION_TYPES.FETCH_USER_PERFORMANCE_LIST_FAILURE:
      return {
        ...state,
        loading: false
      };
    case REPORT_ACTION_TYPES.FETCH_ENROLLED_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.payload.totalCount || 0,
        enrolledPatientList: action.payload.enrolledPatientList || []
      };
    case REPORT_ACTION_TYPES.FETCH_ASSESSMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.payload.totalCount || 0,
        assessmentList: action.payload.assessmentList || []
      };
    case REPORT_ACTION_TYPES.FETCH_USER_PERFORMANCE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.payload.totalCount || 0,
        userPerformanceList: action.payload.userPerformanceList || []
      };
    case REPORT_ACTION_TYPES.FETCH_SS_REPORT_VIEW_REQUEST:
      return {
        ...state,
        ssReport: {
          ...state.ssReport,
          loading: true,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SS_REPORT_VIEW_SUCCESS:
      return {
        ...state,
        ssReport: {
          ...state.ssReport,
          loading: false,
          list: action.payload.list || [],
          total: action.payload.totalCount || 0,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SS_REPORT_VIEW_FAILURE:
      return {
        ...state,
        ssReport: {
          ...state.ssReport,
          loading: false,
          list: [],
          total: 0,
          error: action.error
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_REPORT_VIEW_REQUEST:
      return {
        ...state,
        skReport: {
          ...state.skReport,
          loading: true,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_REPORT_VIEW_SUCCESS:
      return {
        ...state,
        skReport: {
          ...state.skReport,
          loading: false,
          list: action.payload.list || [],
          total: action.payload.totalCount || 0,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_REPORT_VIEW_FAILURE:
      return {
        ...state,
        skReport: {
          ...state.skReport,
          loading: false,
          list: [],
          total: 0,
          error: action.error
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_DETAILS_LIST_REQUEST:
      return {
        ...state,
        skDetails: {
          ...state.skDetails,
          loading: true,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        skDetails: {
          ...state.skDetails,
          loading: false,
          list: action.payload.list || [],
          total: action.payload.totalCount || 0,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_DETAILS_LIST_FAILURE:
      return {
        ...state,
        skDetails: {
          ...state.skDetails,
          loading: false,
          list: [],
          total: 0,
          error: action.error
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_DETAILS_VIEW_REQUEST:
      return {
        ...state,
        skDetails: {
          ...state.skDetails,
          viewLoading: true,
          view: null,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_DETAILS_VIEW_SUCCESS:
      return {
        ...state,
        skDetails: {
          ...state.skDetails,
          viewLoading: false,
          view: action.payload,
          error: null
        }
      };
    case REPORT_ACTION_TYPES.FETCH_SK_DETAILS_VIEW_FAILURE:
      return {
        ...state,
        skDetails: {
          ...state.skDetails,
          viewLoading: false,
          view: null,
          error: action.error
        }
      };
    case REPORT_ACTION_TYPES.CLEAR_SK_DETAILS_VIEW:
      return {
        ...state,
        skDetails: {
          ...state.skDetails,
          view: null,
          viewLoading: false
        }
      };
    default:
      return state;
  }
};

export default reportReducer;
